import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  ApiResponse,
  PaginatedResponse, 
} from "@/lib/types";
import {
  Shipping,
  CreateShippingRequest,
  UpdateShippingRequest,
  GetShippingParams
} from "@/types/shippingTypes";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const shippingApi = createApi({
  reducerPath: "shippingApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: "include",
    prepareHeaders: (headers) => {
      const token = typeof window !== 'undefined' ? localStorage.getItem("accessToken") : null;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Shipping"],
  endpoints: (builder) => ({
    createShipping: builder.mutation<ApiResponse<Shipping>, CreateShippingRequest>({
      query: (data) => ({
        url: "/shipping/create-shipping",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Shipping"],
    }),
    getAllShipping: builder.query<PaginatedResponse<Shipping>, GetShippingParams | void>({
      query: (params) => ({
        url: "/shipping",
        params: params || undefined,
      }),
      providesTags: ["Shipping"],
    }),
    getShippingById: builder.query<ApiResponse<Shipping>, string>({
      query: (id) => `/shipping/${id}`,
      providesTags: ["Shipping"],
    }),
    updateShipping: builder.mutation<ApiResponse<Shipping>, UpdateShippingRequest>({
      query: ({ id, data }) => ({
        url: `/shipping/update-shipping/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Shipping"],
    }),
    deleteShipping: builder.mutation<ApiResponse, string>({
      query: (id) => ({
        url: `/shipping/delete-shipping/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Shipping"],
    }),
  }),
});

export const {
  useCreateShippingMutation,
  useGetAllShippingQuery,
  useGetShippingByIdQuery,
  useUpdateShippingMutation,
  useDeleteShippingMutation,
} = shippingApi;
